<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form label-width="80px" ref="form" :model="queryParams">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="操作账号：" class="item">
                <div
                  style="
                    max-height: 200px;
                    overflow-y: auto;
                    float: left;
                    width: calc(100% - 59px);
                  "
                >
                  <el-input
                    v-if="isExpandUser"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="nickName"
                    size="small"
                    placeholder="操作账号"
                  ></el-input>
                  <el-checkbox @change="handleChangeUser" v-model="isCheckUser"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="queryParams.operNos"
                    placeholder="请选择姓名"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                    @change="handleChangeOper"
                  >
                    <el-checkbox
                      v-for="(item, index) in userList"
                      :key="index"
                      :label="item.userName"
                      v-show="
                        (isExpandUser || index < 10) &&
                        item.nickName &&
                        item.nickName.indexOf(nickName) > -1
                      "
                    >
                      {{ item.nickName }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="userList.length > 10"
                  @click="isExpandUser = !isExpandUser"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #4934b2;
                    float: left;
                  "
                >
                  {{ isExpandUser ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="店铺名称：" class="item">
                <div
                  style="
                    max-height: 200px;
                    overflow-y: auto;
                    float: left;
                    width: calc(100% - 59px);
                  "
                >
                  <el-input
                    v-if="isExpand"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="shopName"
                    size="small"
                    placeholder="店铺名称"
                  ></el-input>
                  <el-checkbox @change="handleChangeShop" v-model="isCheckShop"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="queryParams.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopId"
                      v-show="
                        (isExpand || index < 10) &&
                        item.shopName.indexOf(shopName) > -1
                      "
                    >
                      {{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="shopList.length > 10"
                  @click="isExpand = !isExpand"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #4934b2;
                    float: left;
                  "
                >
                  {{ isExpand ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              prop="groupType"
              label="平台渠道："
              class="hide_input"
            >
              <el-select
                clearable
                v-model="queryParams.platNo"
                placeholder="请选择平台渠道"
                class="input"
                size="small"
              >
                <el-option
                  v-for="(value, index) in dictData['plat_no']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="remitFlag"
              label="寄达国家："
              class="hide_input"
            >
              <el-select
                clearable
                size="small"
                v-model="queryParams.state"
                placeholder="请选择"
              >
                <el-option
                  v-for="(value, index) in dictData['amazon_site']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流方式：" prop="designId">
              <el-select
                clearable
                v-model="queryParams.shippingMethod"
                placeholder="请选择物流方式"
                class="input"
                size="small"
              >
                <el-option
                  v-for="value in shipList"
                  :key="value.shippingMethod"
                  :label="value.shippingMethodName"
                  :value="value.shippingMethod"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="物流状态：" prop="expreStatus">
              <el-select
                clearable
                size="small"
                v-model="queryParams.expreStatus"
                placeholder="请选择"
              >
                <el-option
                  v-for="(value, index) in dictData['expreStatus']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发货时间：" prop="createTime">
              <template>
                <div class="block">
                  <el-date-picker
                    size="small"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    v-model="queryParams.timeRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </div>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单编号：" prop="appNo">
              <el-input
                size="small"
                v-model="queryParams.appNo"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="物流单号：" prop="trackingNumber">
              <el-input
                size="small"
                v-model="queryParams.trackingNumber"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item style="text-align: right">
              <el-button size="small" type="primary" @click="getList"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <div>
        <el-table ref="table" :data="tableData" class="clain-tab" border>
          <el-table-column
            label="物流单号【订单号】"
            align="center"
            prop="expreId"
            width="219"
          >
            <template slot-scope="scope">
              <div>
                <a
                  style="cursor: pointer"
                  @click="handleShowExpre(scope.row)"
                  >{{ scope.row.trackingNumber }}</a
                >
              </div>
              <div>
                【<a
                  :href="`/order/myOrder/order?appNo=${scope.row.appNo}`"
                  target="_blank"
                  >{{ scope.row.appNo }}</a
                >】
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="收件人【寄达国家】"
            align="center"
            prop="state"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.receName }}
              </div>
              <div>【{{ dictMap["amazon_site"][scope.row.state] }}】</div>
            </template>
          </el-table-column>

          <el-table-column label="物流方式" align="center" prop="operNo">
            <template slot-scope="scope">
              <div style="display: inline-block">
                {{ scope.row.shippingMethodName }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="最新消息"
            align="center"
            prop="newProcess"
            width="200"
          >
            <template slot-scope="scope">
              <div
                v-html="
                  scope.row.newProcess
                    ? scope.row.newProcess.replace('|', '<br/>')
                    : ''
                "
                style="display: inline-block"
              ></div>
            </template>
          </el-table-column>
          <el-table-column label="运输时间" align="center" prop="expreTimes">
            <template slot-scope="scope">
              <div style="display: inline-block">
                <span v-if="scope.row.expreTimes > 0"
                  >{{ scope.row.expreTimes }}天</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="物流状态" align="center" prop="expreStatus">
            <template slot-scope="scope">
              <div>{{ dictMap["expreStatus"][scope.row.expreStatus] }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="平台【店铺】"
            align="center"
            prop="createTime"
          >
            <template slot-scope="scope">
              <div>{{ dictMap["plat_no"][scope.row.platNo] }}</div>
              <div>【{{ scope.row.shopName }}】</div>
            </template>
          </el-table-column>
          <el-table-column label="发货时间" align="center" prop="departedTime">
            <template slot-scope="scope">
              <div style="display: inline-block">
                {{ scope.row.departedTime }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <ExpreDetail
      @onClose="handleClose"
      :detail="detail"
      :visible="expreVisible"
    ></ExpreDetail>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {mapGetters} from 'vuex'
import { selectExpreList, getExpreProcess } from "@/api/order/all"
import { getShopList } from "@/api/system/shopManage"
import { getShipMethod } from "@/api/product/shipMethod"
import ExpreDetail from './components/ExpreDetail'
import { listSubAccount } from "@/api/system/user"

export default {
    name: "product",
    components:{Breadcrumb , ExpreDetail},
    data(){
        return{
            // 遮罩层
            loading: true,
            closeDelay:0,
            total:0,
            queryParams:{
                pageNum: 1,
                pageSize: 30,
                platNo: null,
                state: null,
                shopId: [],
                shippingMethod: null,
                beginTime: null,
                endTime: null,
                appNo: '',
                trackingNumber: '',
                timeRange: [],
                expreStatus: null,
                operNos: []
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            groupTypeArray: [
              {label : '多素材组合' ,value: '01'},
               {label : '单元素组合' ,value: '02'},
                {label : '简单商品' ,value: '03'},

            ],
            attribute: {},
            currentAttr: {
              color: "",
              size: "",
            },
            currentSku: {},
            mainPic: '',
            productNum: 1,
            tableData:[],
            detailData: [],
            cartArray: [],
            claimCollIds:[],////选中 的产品id
            claimProduct: [],
            cartDialogVisible: false,
            cartData: [],
            commodity: {},
            totalCount: 0,
            totalNum: 0.00,
            totalPrice: 0.00,

            /*临时字段区--用于记录*/
            lastId: "",
            platList:[],
            shopSelectDialog:false,
            shopList:[],
            shopListClone: [],
            checkAll: false,
            checkedShops: [],
            checkPlat:undefined,
            isIndeterminate: true,
            currentRow:null,
            /* 新增的修改需求用到的字段 */
            colors: [],
            sizes: [],
            form: {},
            singlePrice: '',
            editVisible: false,
            detailVisible: false,
            detailInfo: {},
            editor: null,
            editorConfig:{
              allowedContent: true,//设置为true，以防止CKEditor 4删除不允许的元素
              extraPlugins:['uploadImg'],
              height:'300px',
              toolbar : [
                  [ 'Maximize'],
                  [ 'Bold', 'Italic', 'Underline', 'Strike'],
                  [ 'TextColor', 'BGColor' ],
                  [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                  [ 'HorizontalRule','RemoveFormat'],
                  [ 'Undo', 'Redo' ],
                  '/',
                  [ 'Styles', 'Format', 'Font', 'FontSize' ],
                  [ 'Table'],
                  [ 'uploadImg']
              ],
              language: 'zh-cn',
              wordcount:{
                  showCharCount: true,
              },

            },
            shipList: [],
            expreVisible: false,
            expreList: [],
            detail: {},
            isCheckShop: true,
            shopName: '',
            isExpand: false,
            isExpandUser: false,
            nickName: "",
            isCheckUser: true,
            userList: [],
        }
    },
    computed: {
        ...mapGetters(["dictData", "dictMap", 'nginx',"user"]),
        rowSelectNum(){
                return this.claimCollIds.length;
            },
      },
    watch:{
        shopSelectDialog(val, oldVal){
            if(!val){
                this.checkedShops = [];
            }
        }
    },
    created() {
        let curDate = new Date()
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)
        this.queryParams.timeRange = [this.parseTime(preDate, "{y}-{m}-{d}") , this.parseTime(curDate,"{y}-{m}-{d}")]
        this.getList();
        this.getShopList();
        this.getShip()
        this.getUserList()
    },
    methods:{
        getUserList() {
      listSubAccount({}).then((res) => {
        res.rows.unshift({
          userName: this.user.name,
          nickName: this.user.nickName ? this.user.nickName : this.user.name,
        })
        this.userList = res.rows
      })
    },
     handleChangeOper() {
      let shopList = this._.clone(this.shopListClone)
      this.shopList = shopList.filter((shop) => {
        if (this.queryParams.operNos.includes(this.user.name)) {
          return true
        }
        for (let record of this.userList) {
          if (this.queryParams.operNos.includes(record.userName)) {
            for (let item of record.shops) {
              if (item.shopId == shop.shopId) {
                return true
              }
            }
          }
        }
        return false
      })
      
      this.queryParams.shopId = []
      if (this.queryParams.operNos.length == 0 && this.isCheckUser) {
        this.shopList = this._.clone(this.shopListClone)
      }
    },
       handleClose(){
         this.expreVisible = false
      },
      async handleShowExpre(detail){
        this.expreVisible = true
        this.detail = detail
      },
      getShopList() {
        getShopList().then((res) => {
          this.shopList = res.rows
           this.shopListClone = this._.clone(res.rows)
        })
      },
      getShip() {
        getShipMethod().then((res) => {
          this.shipList = res.rows
        })
      },
      handleExport(){
        if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        this.$router.push(`/carry/proCustom/createTemplateData?designId=${this.claimCollIds.join(',')}&name=${this.claimProduct.join('，')}`)
      },
      async handleGroup(){
        if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        this.$confirm('请确认是否组合商品', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let result = await addGroup({designId : this.claimCollIds.join(',') })
          this.msgSuccess('设置组合成功')
          this.getList()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      handleModifyDesign(row){
        let params = {
          designId: row.designId,
          designProName: row.engProName,
          designEngProName: row.engProName
        }
        updateDesign(params).then(re => {
            this.$message({
                type: 'success',
                message: '保存成功'
            });
            this.getList()
            this.editVisible = false;
          }).catch(err =>{
        });
      },
      handleJumpProduct(row){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { pId: row.pId }} );
        window.open(routeUrl.href, '_blank');
      },
      async  handleJumpDesign(row){
        if(row.groupType == '01'){
          let result = await listGroup({groupDesignId: row.groupDesignId})
          this.detailData = result.rows
          this.detailVisible = true
        }else{
          let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { designId: row.designId }} );
          window.open(routeUrl.href, '_blank');
        }
      },
      handleJumpDetailDesign(designId){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { designId: designId }} );
        window.open(routeUrl.href, '_blank');
      },
      handleJumpDetailProduct(pId){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { pId: pId }} );
        window.open(routeUrl.href, '_blank');
      },
      handleJump(path){
        this.$router.push({path: path})
      },

      async handleAddCart() {
        let cartArray = this._.clone(this.cartArray)
        let form = []
        for(let record of cartArray){
          if(record.shop){
            form.push({
              pId: record.pId,
              designId: record.designId,
              properName: record.currentSku.properName,
              productNum: record.productNum,
              properVal: record.currentSku.properVal,
              skuId:  record.currentSku.skuId,
              productType: record.productType
            })
          }
        }
        if(form.length == 0){
          this.msgError('商品至少需要选择一个')
          return
        }
        try {
          await addCart(form)
          this.$store.dispatch("GetIndexStat")
          this.msgSuccess("加入购物车成功")
        } catch (error) {}
      },
      // table数据
      getList(){
            this.startLoading()
            let params = this._.clone(this.queryParams)
            params.shopId = params.shopId.join(',')
            if(params.timeRange){
              params.beginTime = params.timeRange[0]
              params.endTime = params.timeRange[1]
            }
            params.operNos = params.operNos.join(",")
            delete params["timeRange"]
            selectExpreList(params).then((re) => {
                this.tableData = re.rows;
                this.total = re.total;
                this.endLoading();
            }).catch(err =>{ this.endLoading();});
      },
      handleChangeShop() {
      this.queryParams.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.queryParams.shopId.push(record.shopId)
        })
      }
    },
      async  handleNotGroup(row){
        try {
            this.$confirm('请确认是否取消组合商品', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(async () => {
              let result = await cancelGroup({groupDesignId: row.designId})
              this.msgSuccess('取消组合成功')
              this.getList()
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });

        } catch (error) {

        }
        },
        resetForm(){
          this.queryParams =  {
            pageNum: 1,
            pageSize: 30,
            platNo: null,
            state: null,
            shopId: [],
            shippingMethod: null,
            beginTime: null,
            endTime: null,
            appNo: '',
            trackingNumber: '',
            timeRange: [],
            expreStatus: null,
            operNos: []
          }
          this.$refs['form'].resetFields();
        },
        tableSelectionChange(val){
            this.claimCollIds = [];
            this.claimProduct = [];
            val.forEach(r =>{
                this.claimCollIds.push(r.designId)
                this.claimProduct.push(r.designEngProName)
            });

        },

        /*跳到我的详情*/
        showDetail(row){
            this.$router.push({path:'/carry/proCustom/particulars', query: row})
        },
        handleChangeUser() {
          this.queryParams.operNos = []
          let shopList = this._.clone(this.shopListClone)
          if (this.isCheckUser) {
            this.userList.map((record) => {
              this.queryParams.operNos.push(record.userName)
            })
            this.shopList = shopList
          } else {
            this.shopList = shopList.filter((shop) => {
              for (let record of this.queryParams.operNos) {
                if (record == shop.operNo) {
                  return true
                }
              }
              return false
            })
          }
          this.queryParams.shopId = []
        },

        /*点击加入购物车*/
        async handleShowCart(row) {
          try {
            let cartData = await getCartInfo(row.designId)
            cartData.data.map(record=>{
              record.productNum = 1
              record.currentSku = record.skuList[0]
              record.attribute = JSON.parse(record.attribute)
              record.currentAttr = {color : '', size: ''}
              let colorList = record.attribute['颜色']
              if(colorList && colorList.length == 1){
                record.currentAttr.color = colorList[0]
              }
              // record.currentAttr.size = properVal[1]
              // record.currentAttr
            })
            this.cartArray = cartData.data

            // this.currentSku = cartData.data.skuList[0]
            // this.mainPic = this.currentSku.picList[0].picUrl
            this.cartDialogVisible = true
          } catch (error) {
          }
        },
          /*编辑设计*/
        async handleShowEdit(row) {
          try {
            //获取设计详情
            let cartData = await getCartInfo(row.designId)
            cartData.data.map(record=>{
              record.productNum = 1
              record.currentSku = record.skuList[0]
              record.attribute = JSON.parse(record.attribute)
              record.currentAttr = {}
              let properVal = record.skuList[0].properVal.split(":")
              record.currentAttr.color = properVal[0]
              record.currentAttr.size = properVal[1]
              // record.currentAttr
            })
            this.cartArray = cartData.data
            this.editVisible = true
          } catch (error) {
          }
        },
        handleSetParent(row){
           setGroupMain({designId: row.designId ,groupDesignId: row.groupDesignId}).then(re => {
              this.$message({
                  type: 'success',
                  message: '保存成功'
              });
              for(let record of this.cartArray){
                record.groupDesignId = row.designId
              }
              this.getList()
          }).catch(err =>{

          });
        },
        handleSaveDesign(){
          this.detailInfo.remarks = this.editor.getData()
          updateDesign(this.detailInfo).then(re => {
              this.$message({
                  type: 'success',
                  message: '保存成功'
              });
              this.editVisible = false;
          }).catch(err =>{

          });
        },


        /*确认加入购物车*/
        confirmAddCart() {
            if (this.totalCount == 0) {
                this.$message({
                    message: '请至少添加一件!',
                    type: 'warning'
                });
            } else {
                this.cartDialogVisible = false;
                let i = 0;
                this.cartData.forEach(item =>{
                    i++;
                    if (item.count != 0) {
                        let params ={
                            designId:item.designId,//商品id
                            operNo:this.$store.state.user.name,//操作人
                            properName:'颜色:尺码',
                            properVal:item.color +":"+ item.size,
                            num:item.count,//商品数量
                            price:item.price,//商品价格
                            skuId:item.skuId,
                            selfType:'01',
                        }
                        addToShoppingCart(params); //创建购物车
                    }
                    if (this.cartData.length==i)
                        this.$message({message: "加入购物车成功", type:"success", duration: 700});
                });
                this.lastId = "";
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
            }
        },

        /*购物车弹框的计数*/
        getTotalCount(val1,obj){
            let count = 0; let price = 0.00;
            this.cartData.forEach(item =>{
                if(item.count != 0){
                    count += item.count;
                    price += item.price * item.count;
                }
            })
            this.totalCount = count;
            if (count == 0) {
                this.totalNum = 0.00;
            } else {
                this.totalNum = (price/count).toFixed(2);
            }
            this.totalPrice = price.toFixed(2);
        },

        /*通过商品id获取skuList*/
        getSkuList(designId) {
            if (this.lastId != designId) {
                this.lastId = designId;
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
                getDesignSku(designId).then((re) => {
                  let cacheColor = [];
                  let cacheSize = [];
                  let colors = [];
                  let sizes = [];
                    this.cartData = re.data;
                    re.data.forEach(e => {
                      if (cacheColor.indexOf(e.color) < 0) {
                        cacheColor.push(e.color);
                        colors.push(e);
                      }
                      if (cacheSize.indexOf(e.size) < 0) {
                        cacheSize.push(e.size);
                        sizes.push(e)
                      }
                      });
                    this.colors = colors;
                    this.sizes = sizes;

                })
            }
            this.cartDialogVisible = true;
        },

        handleCommand(val){
            if(this.claimCollIds.length==0){
                this.$message('请选择批量操作的数据！');
                return
            }
        },

        /*添加/修改备注*/
        addRemark(index) {
            let remark = this.tableData[index].remark;
            this.$prompt('请输入备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: remark,
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '格式不正确'
            }).then(({ value }) => {
                if (remark != value) {
                    this.tableData[index].remark = value;
                    updateDesign(this.tableData[index]).then(re => {
                        this.$message({
                            type: 'success',
                            message: '修改成功! 新备注是: ' + value
                        });
                    }).catch(err =>{

                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });
        },

        getEditor(editor){
            this.editor = editor;
        },
        handleSelectColor(record,color) {
          record.currentAttr.color = color
          this.selectSku(record)
        },
        handleSelectSize(record,size ) {
          record.currentAttr.size = size
          this.selectSku(record)
        },
        selectSku(product) {
          for (let record of product.skuList) {
            record.properVal = record.properVal.replace(/\\/g, "")
            if (
              record.properVal ===
              `${product.currentAttr.color}:${product.currentAttr.size}`
            ) {
              product.currentSku = record
              product.shop = true
              break
            }
          }
        },
    }
}
</script>

<style lang="scss" scoped>
.searchBox {
  margin-top: 1.5%;
  border: 1px solid #d7d7d7;
}

.clain-tab {
  min-width: 1200px;

  .img-small {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    border: 1px solid #ccc;
    padding: 1px;
  }
}

.el-table >>> .cell {
  max-height: 120px;
  line-height: 25px !important;
}

.el-dialog__wrapper >>> .el-dialog {
  width: 20%;
}

.cartType .el-row {
  padding: 3% 0px;
  border-bottom: 1px dashed #88888847;
  text-align: center;
}

.cart-but {
  background: #ff5561;
  width: 95%;
  height: 36px;
  font-size: 18px;
  color: white;
  margin-bottom: 2%;
  margin-left: 2%;
  line-height: 0;
}
.wrapper {
  margin-bottom: 5px;
}

.color-wrapper .color-item {
  height: 40px;
  display: inline-block;
  margin-left: 5px;
  padding: 1px;
  border: 1px solid #e3e3e3;
  cursor: pointer;
}

.product-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}
.size-wrapper .size-item {
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 5px;
  padding: 1px 15px;
  border: 1px solid #f0f0f0;
  background: #f0f0f0;
  cursor: pointer;
}
.price-wrapper {
  color: #4934b2;
}
.product-dialog ::v-deep .el-dialog__body {
  height: 60vh;
  overflow-y: auto;
}
.price-wrapper .price {
  font-size: 20px;
  font-weight: 800;
}
.sku-attr {
  overflow: hidden;
  margin-top: 15px;
  padding: 0 0 0 8px;
  .sku-name {
    margin: 0 14px 0 0;
    float: left;
    line-height: 39px;
  }
  .sku-detail {
    float: left;
    margin: 5px 0 0 0;
  }
  .sku-detail {
    width: calc(100% - 58px);
    line-height: 39px;
  }
}
.sku-color {
  margin: 0 8px 0 0;
  border: 1px solid #aaaaaa;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  transition: all 0.5s ease-in-out;
  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
}
.sku-size {
  color: #333;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  text-transform: capitalize;
  display: inline-block;
  margin: 0;
  min-width: 30px;
  overflow: hidden;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 7px;
  transition: all 0.5s ease-in-out;
  padding: 0 12px;
  margin: 0 8px 5px 0;

  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
  cursor: pointer;
  box-sizing: border-box;
}
.is-select {
  border: 2px solid #f25551;
  box-shadow: none;
}
.sku-price {
  font-size: 20px;
}
.expre-detail ::v-deep .el-dialog__body {
  max-height: 56vh;
  overflow-y: auto;
}
.templateName {
  cursor: pointer;
}
</style>
